export default __webpack_public_path__ + "static/media/para-text-ic.72373466.svg";